var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripVideoUnavailable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 53,
    height: 53
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_2476_7595_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#71767C",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 23C32.5 25.2056 30.7056 27 28.5 27H24V26H28.5C30.1542 26 31.5 24.6542 31.5 23C31.5 21.8202 30.8036 20.7455 29.7259 20.262L29.3724 20.1035L29.4377 19.7216C29.4791 19.4798 29.5 19.237 29.5 19C29.5 16.6566 27.5934 14.75 25.25 14.75C23.7454 14.75 22.3831 15.5209 21.606 16.8123L21.3776 17.1918L20.9733 17.0109C20.5864 16.8378 20.1749 16.75 19.75 16.75C18.1788 16.75 16.8646 17.9769 16.758 19.5431L16.7284 19.9784L16.2931 20.008C14.7269 20.1146 13.5 21.4288 13.5 23C13.5 24.6542 14.8458 26 16.5 26H21V27H16.5C14.2944 27 12.5 25.2056 12.5 23C12.5 21.0457 13.9236 19.3896 15.8104 19.0604C16.1396 17.1736 17.7957 15.75 19.75 15.75C20.1721 15.75 20.5844 15.815 20.9807 15.9437C21.9661 14.5626 23.5329 13.75 25.25 13.75C28.1448 13.75 30.5 16.1052 30.5 19C30.5 19.1721 30.4911 19.3464 30.4735 19.5211C31.7158 20.2267 32.5 21.5541 32.5 23ZM23 30.2929V21H22V30.2929L19.8536 28.1464L19.1464 28.8536L22.5 32.2071L25.8536 28.8536L25.1464 28.1464L23 30.2929Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2476_7595_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripVideoUnavailable);
export default __webpack_public_path__ + "static/media/trip-video-unavailable.214393497b6c5be368d48d865caf0ff7.svg";
export { ForwardRef as ReactComponent };